/* Miles & Made theme script: drawer cart, variant picker, reveals. No dependencies. */
(function () {
  'use strict';
  var R = (window.MM && window.MM.routes) || { cart: '/cart', cart_add: '/cart/add', cart_change: '/cart/change' };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- panels (cart drawer + mobile nav) ---------- */
  function panel(id) { return document.getElementById(id); }
  function openPanel(el) {
    if (!el) return;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var btn = el.querySelector('[data-mm-close]:not(.mm-drawer__bg):not(.mm-mnav__bg)');
    if (btn) setTimeout(function () { btn.focus(); }, 50);
  }
  function closePanels() {
    document.querySelectorAll('.mm-drawer.is-open, .mm-mnav.is-open').forEach(function (el) {
      el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    });
    document.documentElement.style.overflow = '';
    document.querySelectorAll('[data-mm-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }

  /* ---------- cart ---------- */
  function renderDrawer(html, count) {
    if (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-mm-drawer]');
      var current = document.querySelector('[data-mm-drawer]');
      if (fresh && current) {
        var wasOpen = current.classList.contains('is-open');
        current.innerHTML = fresh.innerHTML;
        if (wasOpen) { current.classList.add('is-open'); current.setAttribute('aria-hidden', 'false'); }
      }
    }
    if (typeof count === 'number') {
      document.querySelectorAll('[data-mm-count]').forEach(function (c) { c.textContent = count; });
    }
  }
  function refreshCount() {
    return fetch(R.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderDrawer(null, c.item_count); return c; });
  }
  function addToCart(items, button, errEl) {
    if (button) button.classList.add('is-loading');
    if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
    return fetch(R.cart_add + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: 'mm-cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to bag.');
        var html = res.body.sections && res.body.sections['mm-cart-drawer'];
        renderDrawer(html);
        document.dispatchEvent(new CustomEvent('cart:add', { detail: { items: items } }));
        return refreshCount();
      })
      .then(function () {
        if (!window.MM || window.MM.openDrawerOnAdd !== false) {
          var d = document.querySelector('[data-mm-drawer]');
          if (d) openPanel(d); else window.location.href = R.cart;
        }
      })
      .catch(function (e) {
        if (errEl) { errEl.textContent = e.message; errEl.hidden = false; }
        else alert(e.message);
      })
      .finally(function () { if (button) button.classList.remove('is-loading'); });
  }
  function changeLine(line, qty) {
    var d = document.querySelector('[data-mm-drawer]');
    if (d) d.classList.add('is-busy');
    return fetch(R.cart_change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: 'mm-cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        renderDrawer(c.sections && c.sections['mm-cart-drawer'], c.item_count);
        if (document.body.classList.contains('mm-template-cart')) window.location.reload();
      })
      .finally(function () { var d2 = document.querySelector('[data-mm-drawer]'); if (d2) d2.classList.remove('is-busy'); });
  }

  /* ---------- product form ---------- */
  function initProduct(root) {
    if (!root || root.dataset.mmReady) return;
    root.dataset.mmReady = '1';
    var form = root.querySelector('[data-mm-product-form]');
    var dataEl = root.querySelector('[data-mm-variants]');
    if (!form || !dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var cfgEl = root.querySelector('[data-mm-config]');
    var cfg = cfgEl ? JSON.parse(cfgEl.textContent) : { lowStock: 5 };
    var idInput = form.querySelector('[data-mm-variant-id]');
    var priceEl = root.querySelector('[data-mm-price]');
    var compareEl = root.querySelector('[data-mm-compare]');
    var addBtn = form.querySelector('[data-mm-add]');
    var addLabel = form.querySelector('[data-mm-add-label]');
    var stockEl = form.querySelector('[data-mm-stock]');
    var errEl = form.querySelector('[data-mm-error]');
    var track = root.querySelector('[data-mm-track]');
    var slides = root.querySelectorAll('[data-mm-slide]');
    var thumbs = root.querySelectorAll('[data-mm-thumb]');
    var dots = root.querySelectorAll('[data-mm-dot]');
    var sticky = root.querySelector('[data-mm-sticky]');
    var stickyBtn = root.querySelector('[data-mm-sticky-add]');
    var stickyPrice = root.querySelector('[data-mm-sticky-price]');
    function isSwipe() { return track && track.scrollWidth > track.clientWidth + 4; }
    function mark(id) {
      id = String(id);
      slides.forEach(function (x) { x.classList.toggle('is-active', x.dataset.mmSlide === id); });
      thumbs.forEach(function (x) { x.setAttribute('aria-current', x.dataset.mmThumb === id ? 'true' : 'false'); });
      dots.forEach(function (x) { x.classList.toggle('is-on', x.dataset.mmDot === id); });
    }

    function selected() {
      return Array.prototype.map.call(root.querySelectorAll('[data-mm-option]'), function (g) {
        var b = g.querySelector('[aria-checked="true"]');
        return b ? b.dataset.value : null;
      });
    }
    function showMedia(id, instant) {
      var sl = root.querySelector('[data-mm-slide="' + id + '"]');
      if (!sl) return;
      mark(id);
      if (isSwipe()) track.scrollTo({ left: sl.offsetLeft - track.offsetLeft, behavior: instant ? 'auto' : 'smooth' });
    }
    if (track) {
      var act = root.querySelector('.mm-slide.is-active');
      if (act && act !== slides[0]) requestAnimationFrame(function () { showMedia(act.dataset.mmSlide, true); });
      var tick = null;
      track.addEventListener('scroll', function () {
        if (tick) return;
        tick = requestAnimationFrame(function () {
          tick = null;
          if (!isSwipe()) return;
          var i = Math.round(track.scrollLeft / track.clientWidth);
          var sl = slides[Math.max(0, Math.min(slides.length - 1, i))];
          if (sl) mark(sl.dataset.mmSlide);
        });
      }, { passive: true });
    }
    if (sticky && stickyBtn && 'IntersectionObserver' in window) {
      var buyRow = form.querySelector('.mm-buy');
      new IntersectionObserver(function (es) {
        var en = es[0];
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        stickyBtn.tabIndex = show ? 0 : -1;
      }).observe(buyRow || addBtn);
      stickyBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;
        if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click();
      });
    }
    function syncSticky(v) {
      if (!stickyBtn) return;
      stickyBtn.disabled = !(v && v.available);
      stickyBtn.textContent = !v ? 'Unavailable' : (v.available ? 'Add to bag' : 'Sold out');
      if (stickyPrice && v) stickyPrice.textContent = v.price;
    }
    function update() {
      var opts = selected();
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      if (!v) {
        addBtn.disabled = true; addLabel.textContent = 'Unavailable';
        syncSticky(null);
        return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (compareEl) { compareEl.hidden = !v.compare; compareEl.textContent = v.compare || ''; }
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? 'Add to bag — ' + v.price : 'Sold out';
      if (stockEl) {
        var low = v.qty !== null && v.qty > 0 && v.qty <= cfg.lowStock;
        stockEl.hidden = !low; stockEl.textContent = low ? 'Only ' + v.qty + ' left' : '';
      }
      syncSticky(v);
      if (v.media) showMedia(v.media);
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-mm-option] [data-value]');
      if (opt) {
        var g = opt.closest('[data-mm-option]');
        g.querySelectorAll('[data-value]').forEach(function (b) { b.setAttribute('aria-checked', b === opt ? 'true' : 'false'); });
        var nm = g.querySelector('[data-mm-opt-name]'); if (nm) nm.textContent = opt.dataset.value;
        update(); return;
      }
      var th = e.target.closest('[data-mm-thumb]');
      if (th) { showMedia(th.dataset.mmThumb); return; }
      var st = e.target.closest('[data-mm-step]');
      if (st) {
        var q = form.querySelector('[data-mm-qty-input]');
        q.value = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(st.dataset.mmStep, 10));
      }
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = Math.max(1, parseInt(form.querySelector('[data-mm-qty-input]').value, 10) || 1);
      addToCart([{ id: Number(idInput.value), quantity: q }], addBtn, errEl);
    });
  }

  /* ---------- reveal + header + parallax ---------- */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { threshold: 0, rootMargin: '0px 0px -8% 0px' }) : null;
  var touchLike = window.matchMedia('(max-width: 1020px), (hover: none)');
  function initReveal(scope) {
    (scope || document).querySelectorAll('.mm-reveal:not(.is-in), .mm-stitch:not(.is-in)').forEach(function (el) {
      if (io && !reduceMotion) io.observe(el); else el.classList.add('is-in');
    });
  }
  function initAll(scope) {
    initReveal(scope);
    (scope || document).querySelectorAll('[data-mm-product]').forEach(initProduct);
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-mm-open]');
    if (open) { e.preventDefault(); open.setAttribute('aria-expanded', 'true'); openPanel(panel(open.dataset.mmOpen)); return; }
    var cartOpen = e.target.closest('[data-mm-cart-open]');
    if (cartOpen && !document.body.classList.contains('mm-template-cart')) {
      var d = document.querySelector('[data-mm-drawer]');
      if (d) { e.preventDefault(); openPanel(d); }
      return;
    }
    if (e.target.closest('[data-mm-close]')) { closePanels(); return; }
    var line = e.target.closest('[data-mm-line]');
    if (line) { e.preventDefault(); changeLine(Number(line.dataset.mmLine), Math.max(0, Number(line.dataset.mmQty))); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanels(); });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-mm-quick-add]');
    if (!f) return;
    e.preventDefault();
    var id = f.querySelector('[name="id"]').value;
    addToCart([{ id: Number(id), quantity: 1 }], f.querySelector('button'));
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-mm-autosubmit]')) e.target.form.submit();
    if (e.target.matches('[data-mm-sort]')) {
      var u = new URL(window.location.href); u.searchParams.set('sort_by', e.target.value); u.searchParams.delete('page');
      window.location.href = u.toString();
    }
  });

  var hd = document.querySelector('[data-mm-header]');
  window.addEventListener('scroll', function () {
    if (hd) { var sc = window.scrollY > 10; if (sc !== hd.classList.contains('is-scrolled')) hd.classList.toggle('is-scrolled', sc); }
    if (reduceMotion || touchLike.matches) return;
    document.querySelectorAll('[data-mm-parallax] .mm-band__media').forEach(function (m) {
      var r = m.parentElement.getBoundingClientRect();
      if (r.bottom > 0 && r.top < window.innerHeight) {
        var y = Math.max(-40, Math.min(40, (r.top + r.height / 2 - window.innerHeight / 2) * -0.08));
        m.style.transform = 'translateY(' + y + 'px)';
      }
    });
  }, { passive: true });

  /* Theme Editor support */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) { e.target.classList && e.target.classList.add('is-in'); });

  initAll(document);
  requestAnimationFrame(function () { document.body.classList.add('is-loaded'); });
})();
